import { render } from "./FeaturedSection.vue?vue&type=template&id=2ec045e1&scoped=true"
import script from "./FeaturedSection.vue?vue&type=script&lang=js"
export * from "./FeaturedSection.vue?vue&type=script&lang=js"

import "./FeaturedSection.vue?vue&type=style&index=0&id=2ec045e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec045e1"]])

export default __exports__